export default {
  lotSize: {
    anyLabel: 'Any size',
    interval: 25,
    marksPrefix: '',
    marksSuffix: '',
    max: 500,
    min: 0,
    rangeMax: 500,
    rangeMin: 0
  },
  props: {
    anyLabel: 'Any value',
    interval: 5,
    marksPrefix: '',
    marksSuffix: '',
    max: 100,
    min: 0,
    rangeMax: 100,
    rangeMin: 0
  },
  squareFeet: {
    anyLabel: 'Any Size',
    interval: 200,
    marksSuffix: ' ft',
    max: 8000,
    min: 0,
    rangeMax: 8000,
    rangeMin: 0
  }
};
